import { render, staticRenderFns } from "./Passport.vue?vue&type=template&id=1a6ad896"
import script from "./Passport.vue?vue&type=script&lang=js"
export * from "./Passport.vue?vue&type=script&lang=js"
import style0 from "./Passport.vue?vue&type=style&index=0&id=1a6ad896&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports